// The end-of-session recap, shown when the coach calls finish_session. Overlays
// the transcript so the takeaways are the last thing on screen.

export default function SessionSummary({ summary, onDismiss }) {
  if (!summary) return null;

  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-slate-950/85 p-6">
      <div className="w-full max-w-lg rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-2xl">
        <h2 className="text-lg font-semibold text-slate-100">Session recap</h2>

        <p className="mt-1 text-xs text-slate-500">
          {summary.practiced_count}/{summary.total} phrases practised
          {summary.file ? ' · saved' : ''}
          {summary.cost_usd != null && (
            <>
              {' · '}
              {summary.cost_usd < 0.01
                ? '<$0.01'
                : `$${Number(summary.cost_usd).toFixed(2)}`}
            </>
          )}
        </p>

        {summary.summary && (
          <p className="mt-4 text-sm leading-relaxed text-slate-300">{summary.summary}</p>
        )}

        {summary.strong?.length > 0 && (
          <div className="mt-4">
            <h3 className="text-xs font-semibold uppercase tracking-wider text-emerald-400">
              Solid
            </h3>
            <ul className="mt-1 space-y-0.5">
              {summary.strong.map((p) => (
                <li key={p} className="text-sm text-slate-300">✓ {p}</li>
              ))}
            </ul>
          </div>
        )}

        {summary.needs_work?.length > 0 && (
          <div className="mt-4">
            <h3 className="text-xs font-semibold uppercase tracking-wider text-amber-400">
              Work on next time
            </h3>
            <ul className="mt-1 space-y-0.5">
              {summary.needs_work.map((p) => (
                <li key={p} className="text-sm text-slate-300">• {p}</li>
              ))}
            </ul>
          </div>
        )}

        <button
          type="button"
          onClick={onDismiss}
          className="mt-6 w-full rounded-lg bg-sky-600 py-2 text-sm font-medium text-white hover:bg-sky-500"
        >
          Close
        </button>
      </div>
    </div>
  );
}
